import './TableEmptyState.scss';

interface TableEmptyStateProps {
  message?: string;
}

export const TableEmptyState = ({ message = 'No rows to show.' }: TableEmptyStateProps) => (
  <div className='table-empty-state' data-testid='table-empty-state'>
    {message}
  </div>
);
